import { TCText } from "../../../components/TCText/TCText";
import { Colors } from "../../../utils/colors";
import PlayStore from "../../../assets/download_play_store.png";
import AppStore from "../../../assets/download_app_store.png";
import { useAppPlayStore } from "../../../hooks/useAppPlayStore";

type Props = {
  style?: React.CSSProperties;
  textStyle?: React.CSSProperties;
};

export const DownloadUltraAppOverlay: React.FC<Props> = ({
  style,
  textStyle,
}) => {
  const { handleAndroidClick, handleIOSClick } = useAppPlayStore();
  return (
    <div
      style={{
        backdropFilter: "blur(6px)",
        WebkitBackdropFilter: "blur(6px)",
        position: "absolute",
        left: 0,
        right: 0,
        top: 100,
        bottom: 0,
        zIndex: 99999,
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-end",
        alignItems: "center",
        padding: "16px",
        gap: "16px",
        ...style,
      }}>
      <TCText
        style={{
          textAlign: "center",
          color: Colors.white,
          fontSize: 16,
          fontWeight: 500,
          ...textStyle,
        }}
        value="See your detailed stats in the ULTRA AI Sports App now"
      />
      <div
        style={{
          display: "flex",
          gap: "12px",
          justifyContent: "center",
          paddingBottom: 20,
        }}>
        <img
          src={AppStore}
          alt="Download on App Store"
          onClick={handleIOSClick}
          style={{
            maxWidth: "140px",
            height: "auto",
            cursor: "pointer",
            borderRadius: "8px",
          }}
        />

        <img
          src={PlayStore}
          alt="Get it on Play Store"
          onClick={handleAndroidClick}
          style={{
            maxWidth: "140px",
            height: "auto",
            cursor: "pointer",
            borderRadius: "8px",
          }}
        />
      </div>
    </div>
  );
};
